import React, { useState } from "react";
import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts";
import HighchartMore from "highcharts/highcharts-more";
// import { useTranslation } from "react-i18next";
import { Alert, Card } from "react-bootstrap";
require("highcharts/modules/exporting")(Highcharts);
HighchartMore(Highcharts);
require("highcharts-grouped-categories")(Highcharts);

const ChartComponent = ({ options, className = "", callback, refrs }) => {
  if (options) {
    if (options.xAxis) options.xAxis.gridLineWidth = 0;
    if (options.yAxis) options.yAxis.gridLineWidth = 0;
    options.colors = ["#4D9DE0"];
  }

  // const [t] = useTranslation();

  return (
    <div className={`bg-darkblue border-0 ${className}`}>
      <Card.Body>
        <div id="chart-wrapper" className="chart-wrapper">
          {options ? (
            <HighchartsReact
              highcharts={Highcharts}
              allowChartUpdate={true}
              containerProps={{ style: { width: "100%" } }}
              options={options}
              ref={refrs}
              callback={callback}
            />
          ) : (
            <Alert variant="warning" className="text-center my-3">
              {/* {t("Loading")} */}
              {"Loading"}
            </Alert>
          )}
        </div>
      </Card.Body>
    </div>
  );
};

export default ChartComponent;
